module.exports = __webpack_public_path__ + "img/112026.cff96e8a.png";